import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CloudinaryImage from "../Common/CloudinaryImage";

function BlogCover({ src, alt, ...props }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        aspectRatio: "16 / 9",
        borderRadius: 2,
        overflow: "hidden",
        border: `1px solid ${theme.palette.grey[300]}`,
      }}
    >
      <CloudinaryImage
        src={src}
        alt={alt}
        {...props}
        layout="fill"
        objectFit="cover"
      />
    </Box>
  );
}

export default BlogCover;
